import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const TariffServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const TariffServiceConfigDtoSchema = serviceConfigSchema;

export { TariffServiceConfigDtoSchema, TariffServiceConfigSchema };
//# sourceMappingURL=TariffServiceConfig.js.map
